import MultiStepWizard from "./MultiStepWizard";
import { IStep } from "./Step";
import { Modal, ModalHeader } from "reactstrap";
import { MisterIcon } from "@rtel/mister-icons";
import styles from "./MultiStepWizard.module.css"

const MultiStepWizardModal: React.FC<MultiStepWizardModalProps> = ({
  closeWizard, 
  isModalOpen, 
  title, 
  steps,
  isActive,
}) => {

  return ( 
    <Modal
        size="xl"
        className="modal-fullscreen d-grid"
        isOpen={isModalOpen}
      >
        <ModalHeader className={styles.header}>
          <span className={styles.modaltitle}>{title}</span>
          <button
            className={styles.closebutton}
            onClick={closeWizard}
          >
            <MisterIcon name="XClose" size="sm" />
          </button>
        </ModalHeader>
        <div className={styles.wizardContent}>      
          <MultiStepWizard 
            steps={steps} 
            isActive={isActive}   
          />
        </div>  
      </Modal>
  )
}

export default MultiStepWizardModal;

interface MultiStepWizardModalProps {
  closeWizard: () => void;
  isModalOpen?: boolean;
  title: string;
  steps: IStep [];
  isActive: (index: number) => boolean;
}

MultiStepWizardModal.defaultProps = {
  isModalOpen: true
}